<template>
  <article class="gc-cat" @click="navigate">
    <div class="gc-cat-media">
      <img :src="cover" :alt="category.name || 'Category'" loading="lazy" />
    </div>
    <div class="gc-cat-body">
      <h3>{{ category.name }}</h3>
      <small v-if="category.children">
        {{ category.children }}
        {{ category.children == 1 ? "subcategory" : "subcategories" }}
      </small>
      <small v-else-if="category.products >= 0">
        {{ category.products }}
        {{ category.products == 1 ? "item" : "items" }}
      </small>
    </div>
  </article>
</template>

<script>
import Store from "../../services/store";

export default {
  name: "CategoryItem",

  props: ["grid", "category", "isSearch", "iheight"],

  methods: {
    getOriginalAssetURL(data, sid) {
      return Store.getOriginalAssetURL(data, sid);
    },

    navigate() {
      this.$parent.gsearch = "";
      this.$router
        .push({
          name: "category",
          params: { slug: this.category.slug || this.category._id },
        })
        .catch(() => {});
    },
  },

  computed: {
    cover() {
      let photos = this.category && this.category.photos;
      if (photos && photos.length) photos = photos.filter((x) => x && x.includes("png"));
      const photo = photos && photos.length ? photos[0] : "";
      return this.getOriginalAssetURL(photo, this.category && this.category.store);
    },
  },

  data() {
    return {
      lazy: require("@/assets/imgs/placeholder.png"),
    };
  },
};
</script>
